import { PageHeaderWrapper, Pill, Title } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

interface FiltersHeaderProps {
  activeFiltersCount: number;
}

export function FiltersHeader(props: FiltersHeaderProps) {
  const { activeFiltersCount } = props;

  return (
    <PageHeaderWrapper variant="tertiary">
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 4, paddingY: 2 }}>
        <Title variant="h2" component="h4">
          Filters
        </Title>
        {activeFiltersCount > 0 && (
          <Pill
            variant="outlined"
            size="small"
            label={`${activeFiltersCount} applied`}
            sx={{
              transform: "translateY(-0.375rem)",
            }}
          />
        )}
      </Box>
    </PageHeaderWrapper>
  );
}
